import * as React from 'react';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import type { MarketplaceStore } from '../../component-decorators/with-marketplace-store';
import { withMarketplaceStore } from '../../component-decorators/with-marketplace-store';
import s from './DeveloperPageContainer.scss';
import { composer } from '../../component-decorators/composer';
import { CenteredLoader } from '../centered-loader';
import { useConfigContext } from '../../config-context';
import { FluidContainer } from '../FluidContainer';
import { DeveloperAppsSection } from '@wix/app-market-core-components';
import { QueryDecorator } from '@wix/app-market-core';
import { fetchDeveloperPageData } from './fetchDeveloperPageData';
import { DeveloperPageTopSection } from './developer-page-top-section';
import type { Company } from '@wix/ambassador-marketplace/types';
import { config } from '../../config';
import { Origin } from '../..';
import { DeveloperPageSeo } from './developer-page-seo';

export interface IDeveloperPageProps extends Partial<WithTranslationProps> {
  marketplaceStore?: MarketplaceStore;
  slug: string;
  companyInfo: Company;
}

@withMarketplaceStore
class DeveloperPage extends React.Component<IDeveloperPageProps, any> {
  getIconUrl() {
    return this.props?.companyInfo?.assetsMap?.companyIcon?.assets?.[0]?.url;
  }
  render() {
    const { averageRating, webSolutions = [] } = this.props?.companyInfo || {};

    return (
      <>
        <FluidContainer className={s.conatiner}>
          <DeveloperPageTopSection
            icon={this.getIconUrl()}
            name={this.props?.companyInfo?.companyBase?.name}
            t={this.props.t}
            appsCount={webSolutions.length}
            averageRating={averageRating}
            marketplaceStore={this.props.marketplaceStore}
          />
          <div className={s.developerAppsSection}>
            <DeveloperAppsSection
              appIds={webSolutions.map((solution) => solution.id)}
            />
          </div>
        </FluidContainer>
      </>
    );
  }
}

export const DeveloperPageContainer = composer()
  .withTranslation()
  .compose((props) => {
    const { locale, rpcClient } = useConfigContext();

    return (
      <QueryDecorator
        queryFn={fetchDeveloperPageData(props.slug, locale, rpcClient)}
        queryKey={`developer-${props.slug}-${locale}`}
      >
        {({ data: fetchData, isLoading }) => {
          if (isLoading) {
            return <CenteredLoader />;
          }
          return (
            <>
              {config.origin === Origin.STANDALONE && (
                <DeveloperPageSeo
                  developerName={fetchData.company?.companyBase?.name}
                  developerSlug={props.slug}
                />
              )}
              <DeveloperPage
                slug={props.slug}
                companyInfo={fetchData.company}
                t={props.t}
              />
            </>
          );
        }}
      </QueryDecorator>
    );
  });
